export const replaceUrlHost = (url, origin) => {
  try {
    const targetOrigin = new URL(origin);
    const updatedUrl = new URL(url, targetOrigin);

    updatedUrl.host = targetOrigin.host;

    return updatedUrl.toString();
  } catch {
    return url;
  }
};
